export type FileMimeInfo = {
  mime: string;
  type: string;
  ext: string;
  protected?: boolean;
};

export const MimeTypes: Record<string, FileMimeInfo> = {
  au: { mime: 'audio/basic', type: 'audio', ext: 'au' },
  mp2: { mime: 'audio/mpeg', type: 'audio', ext: 'mp2' },
  mp3: { mime: 'audio/mpeg', type: 'audio', ext: 'mp3' },
  wav: { mime: 'audio/x-wav', type: 'audio', ext: 'wav' },
  mov: { mime: 'video/quicktime', type: 'video', ext: 'mov' },
  movie: { mime: 'video/x-sgi-movie', type: 'video', ext: 'movie' },
  avi: { mime: 'video/x-msvideo', type: 'video', ext: 'avi' },
  mp4: { mime: 'video/mp4', type: 'video', ext: 'mp4' },
  mpa: { mime: 'video/mpeg', type: 'video', ext: 'mpa' },
  mpe: { mime: 'video/mpeg', type: 'video', ext: 'mpe' },
  mpeg: { mime: 'video/mpeg', type: 'video', ext: 'mpeg' },
  mpg: { mime: 'video/mpeg', type: 'video', ext: 'mpg' },
  qt: { mime: 'video/quicktime', type: 'video', ext: 'qt' },
  pdf: { mime: 'application/pdf', type: 'document', ext: 'pdf' },
  pps: { mime: 'application/vnd.ms-powerpoint', type: 'document', ext: 'pps' },
  ppt: { mime: 'application/vnd.ms-powerpoint', type: 'document', ext: 'ppt' },
  pptx: {
    mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    type: 'document',
    ext: 'pptx'
  },
  doc: { mime: 'application/msword', type: 'document', ext: 'doc' },
  docx: {
    mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    type: 'document',
    ext: 'docx'
  },
  xlb: { mime: 'application/vnd.ms-excel', type: 'document', ext: 'xlb' },
  xls: { mime: 'application/vnd.ms-excel', type: 'document', ext: 'xls' },
  xlsx: {
    mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    type: 'document',
    ext: 'xlsx'
  },
  wiz: { mime: 'application/msword', type: 'document', ext: 'wiz' },
  txt: { mime: 'text/plain', type: 'document', ext: 'txt' },
  bmp: { mime: 'image/x-ms-bmp', type: 'image', ext: 'bmp' },
  gif: { mime: 'image/gif', type: 'image', ext: 'gif' },
  jpe: { mime: 'image/jpeg', type: 'image', ext: 'jpe' },
  jpeg: { mime: 'image/jpeg', type: 'image', ext: 'jpeg' },
  jpg: { mime: 'image/jpeg', type: 'image', ext: 'jpg' },
  svg: { mime: 'image/svg+xml', type: 'image', ext: 'svg' },
  webp: { mime: 'image/webp', type: 'image', ext: 'webp' },
  ras: { mime: 'image/x-cmu-raster', type: 'image', ext: 'ras' },
  rgb: { mime: 'image/x-rgb', type: 'image', ext: 'rgb' },
  png: { mime: 'image/png', type: 'image', ext: 'png' },
  tif: { mime: 'image/tiff', type: 'image', ext: 'tif' },
  tiff: { mime: 'image/tiff', type: 'image', ext: 'tiff' },
  xbm: { mime: 'image/x-xbitmap', type: 'image', ext: 'xbm' },
  tar: { mime: 'application/x-tar', type: 'image', ext: 'tar' },
  zip: { mime: 'application/zip', type: 'image', ext: 'zip' }
};

export const getMimeInfo = (fileType: string): FileMimeInfo | undefined => {
  const ext = Object.keys(MimeTypes).find((key) => MimeTypes[key].mime === fileType);
  if (ext) {
    return MimeTypes[ext];
  }
  return undefined;
};

export const getFileExtension = (filename: string) => {
  // get file extension
  const extension = filename.split('.').pop();
  return extension;
};

export const getMimeInfoFromName = (fileName: string): FileMimeInfo | undefined => {
  const extension = getFileExtension(fileName);
  const ext = Object.keys(MimeTypes).find((key) => key == extension);
  if (ext) {
    return MimeTypes[ext];
  }
  return undefined;
};

// Given file exts without dot (Keys of MimeTypes) returns the `MimeType[ext].mime` values mapping
// Ex: args => ['pdf', 'jpeg']
// returns => ['application/document', 'image/jpeg']
export const getMimeTypesFromExts = (extensions: string[]): string[] => {
  const supportedFileMimes = Object.keys(MimeTypes)
    .filter((key) => extensions.includes(key))
    .map((key) => MimeTypes[key].mime);

  return supportedFileMimes;
};
